/**
 * @generated SignedSource<<78034ce7f030fa300384eb58f8200542>>
 * @relayHash efdcf255217923d839e432d525a93ad5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a7d60470854c8a9dc42bc61aa72549d57104157ff6d48179455097bd0e8083da

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResultsCqlQuery$variables = {
  after?: string | null | undefined;
  cql: string;
  first?: number | null | undefined;
};
export type searchResultsCqlQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"searchResultsCql_AtlassianSearchPage">;
};
export type searchResultsCqlQuery = {
  response: searchResultsCqlQuery$data;
  variables: searchResultsCqlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "cql",
    "variableName": "cql"
  },
  (v4/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "searchResultsCqlQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "searchResultsCql_AtlassianSearchPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "searchResultsCqlQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConfluenceSearchResponse",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "url"
                  },
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "webui"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "title"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "excerpt"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "lastModified"
                  },
                  {
                    "concreteType": "LinksContextBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "base"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "filters": [
          "cql"
        ],
        "handle": "connection",
        "key": "SearchResultsCQLPagination__confluence_search",
        "kind": "LinkedHandle",
        "name": "confluence_search"
      }
    ]
  },
  "params": {
    "id": "a7d60470854c8a9dc42bc61aa72549d57104157ff6d48179455097bd0e8083da",
    "metadata": {},
    "name": "searchResultsCqlQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8714af4459ffedbd0699977be49d7cf7";

export default node;
